function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.79 0H1.684C.758 0 0 .655 0 1.455v10.181h1.684V1.455H11.79V0zm2.526 2.91H5.053c-.927 0-1.685.654-1.685 1.454v10.181c0 .8.758 1.455 1.685 1.455h9.263c.926 0 1.684-.655 1.684-1.454V4.364c0-.8-.758-1.455-1.684-1.455zm0 11.636H5.053V4.364h9.263v10.181z",
  fill: "#000"
});

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjc4OTUgMEgxLjY4NDIxQzAuNzU3ODk1IDAgMCAwLjY1NDU0NSAwIDEuNDU0NTVWMTEuNjM2NEgxLjY4NDIxVjEuNDU0NTVIMTEuNzg5NVYwWk0xNC4zMTU4IDIuOTA5MDlINS4wNTI2M0M0LjEyNjMyIDIuOTA5MDkgMy4zNjg0MiAzLjU2MzY0IDMuMzY4NDIgNC4zNjM2NFYxNC41NDU1QzMuMzY4NDIgMTUuMzQ1NSA0LjEyNjMyIDE2IDUuMDUyNjMgMTZIMTQuMzE1OEMxNS4yNDIxIDE2IDE2IDE1LjM0NTUgMTYgMTQuNTQ1NVY0LjM2MzY0QzE2IDMuNTYzNjQgMTUuMjQyMSAyLjkwOTA5IDE0LjMxNTggMi45MDkwOVpNMTQuMzE1OCAxNC41NDU1SDUuMDUyNjNWNC4zNjM2NEgxNC4zMTU4VjE0LjU0NTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { SvgCopy as ReactComponent };